module.exports = __webpack_public_path__ + "static/media/Wishiwashi_gaussian2.dbc3335e.png";